import { render } from "./ViewLeitura.vue?vue&type=template&id=397d444c&scoped=true"
import script from "./ViewLeitura.vue?vue&type=script&lang=js"
export * from "./ViewLeitura.vue?vue&type=script&lang=js"

import "./ViewLeitura.vue?vue&type=style&index=0&id=397d444c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397d444c"]])

export default __exports__